<template>
  <cbm-card
    title="Ticket médio"
    is-currency
    :number-text="value"
    :percent-text="percentageText"
    :percent-description="percentageDescription"
    :tooltip="tooltip"
    :percentage-tooltip="percentageTooltip"
    simple-card
    :boolean-loader="loading"
  />
</template>

<script>
import CbmCard from '@/components/CbmCard.vue'
import { localeString } from '@/config/helpers.js'

export default {
  name: 'ResultsAverageTicketCard',
  components: {
    CbmCard,
  },
  props: {
    metrics: Object,
    loading: {
      type: Boolean,
      default: false,
    },
    isMercapromo: {
      type: Boolean,
      default: false,
    },
    offerType: {
      type: String,
      default: '',
    },
  },
  computed: {
    value() {
      return localeString(this.metrics?.clients_metrics?.with_sales?.average_ticket || 0, 2)
    },
    percentageText() {
      if (this.isMercapromo && this.offerType !== 'percentage') return ''
      let percent = 0
      if (this.metrics?.clients_metrics?.with_sales?.average_ticket && this.metrics?.clients_metrics?.total?.average_ticket) {
        percent = (this.metrics?.clients_metrics?.with_sales?.average_ticket / this.metrics?.clients_metrics?.total?.average_ticket - 1) * 100
      }
      return this.concatPercent(this.concatSum(localeString(percent, 2)))
    },
    percentageDescription() {
      if (this.isMercapromo && this.offerType !== 'percentage') return ''
      return 'do ticket médio geral'
    },
    percentageTooltip() {
      return `Ticket médio geral: R$${
        this.metrics?.clients_metrics?.total?.average_ticket ? localeString(this.metrics?.clients_metrics?.total?.average_ticket, 1) : 0
      }`
    },
    tooltip() {
      return 'Ticket médio dos cupons com algum produto da oferta'
    },
  },
  methods: {
    concatSum(value) {
      const numberValue = typeof value === 'string' ? Number(value.replace(',', '.')) : value
      return numberValue > 0 ? '+' + value : value
    },
    concatPercent(value) {
      return value + '%'
    },
  },
}
</script>
